import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { OrderExtendedListQuery } from '~/graphql/types'

@Module({
  name: 'admin-order',
  stateFactory: true,
  namespaced: true,
})
export default class AdminOrder extends VuexModule {
  fetchStarted = false
  loading = true
  _items: OrderExtendedListQuery['order'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(list) {
    this._items = list
  }

  get items() {
    return this._items
  }
}
